// import { EmailIcon, PhoneIcon } from "@chakra-ui/icons";
import {
  Box,
  Link,
  // Divider,
  // Button,
  Flex,
  Heading,
  HStack,
  Icon,
  IconButton,
  // SimpleGrid,
  Text,
  Textarea,
  Input,
  // useColorModeValue,
  VStack,
  FormControl,
  FormLabel,
  // Button,
} from "@chakra-ui/react";
import { useFormik } from "formik";
// import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
// import {
//   FaClock,
//   FaEnvelope,
//   FaMapMarkerAlt,
//   FaPencilAlt,
//   FaPhone,
// } from "react-icons/fa";
import * as Yup from "yup";
import Colors from "../../../assets/colors/Colors";
import CommonToastMessage from "../../../components/alert/CommonToastMessage";
import {
  CommonFormButton,
  // CommonInput,
  // CommonLable,
} from "../../../components/index";
import * as Constants from "../../../constants/Constants";
import Header from "../header/Header";
import { useHomeHook } from "../home/useHomeHook";
import { getContact, handleExportContact } from "./ContactService";
import glass20 from "../../../assets/images/glass20.png";
import { MdPhone, MdLocationOn, MdAccessTime, MdEmail } from "react-icons/md";
import { FaFileExcel } from "react-icons/fa";
// import { FiSend, FiLock, FiBriefcase, FiArrowRight } from "react-icons/fi";
import Footer from "../footer/Footer";
// import { useAuth } from 'context/AuthContext';
import { FiPower } from "react-icons/fi";

// const MotionBox = motion(Box);
// const ContactInfo = ({ icon, title, content }) => (
//   <HStack spacing={4} mb={4}>
//     <Icon as={icon} w={6} h={6} color="teal.500" />
//     <Box>
//       <Text fontWeight="bold" color="teal.600">
//         {title}
//       </Text>
//       <Text color="#000000">{content}</Text>
//     </Box>
//   </HStack>
// );

const Contact = (props) => {
  const { addToast } = CommonToastMessage();
  const [allformik, setAllformik] = useState(false);
  // const [isAdmin] = useState("");
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [handleMenuEnter, handleMenuLeave, menuVisible, setHoveredItem] =
    useHomeHook(props);
  // const { user } = useAuth();
  // const isAdmin = user?.role === 'admin';
  // const MotionBox = motion(Box);
  // const MotionButton = motion(Button);
  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      note: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required."),
      phone: Yup.string()
        .matches(/^\d+$/, "Invalid Phone Number.")
        .required("Phone is required."),
      email: Yup.string()
        .email("Invalid Email Address.")
        .required("Email is required."),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await getContact(values);
        setAllformik(false);
        formik.resetForm();
        localStorage.setItem("contactSubmitted", "true");
        // addToast({
        //   alertStatus: "Success",
        //   alertTitle: "Success",
        //   // alertTitle: Constants.TOAST_TYPE_SUCESS,
        //   alertDescription: response.data.message,
        // });
        addToast({
          alertStatus: Constants.TOAST_TYPE_SUCESS,
          alertTitle: Constants.TOAST_HEADING_SUCCESS,
          alertDescription: response.data.message,
        });
      } catch (error) {
        addToast({
          alertStatus: Constants.TOAST_TYPE_WARNING,
          alertTitle: Constants.TOAST_HEADING_SUCCESS,
          alertDescription: error.response.data.message,
        });
      }
    },
  });
  //   const handleSubmitClick = () => {
  //   if (allformik) {
  //     setAllformik(false);
  //   }
  //   formik.handleSubmit();
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleLogout = () => {
    sessionStorage.clear();
  };
  // const cardBg = useColorModeValue("white", "#000000");
  // const inputBg = useColorModeValue('#000000', '#000000');
  // const inputBorderColor = useColorModeValue("#000000", "#000000");
  // const headingColor = useColorModeValue("teal.700", "teal.300");
  // const textColor = useColorModeValue("#000000", "#000000");
  return (
    <Box>
      <Header
        handleMenuEnter={handleMenuEnter}
        handleMenuLeave={handleMenuLeave}
        menuVisible={menuVisible}
        setHoveredItem={setHoveredItem}
        collections={[
          { name: "Sliding Partitions", path: "/product/1" },
          { name: "Swing Partitions", path: "/product/2" },
          // { name: "Flush Doors", path: "/product/3" },
          { name: "Bathroom & Wardrobes", path: "/product/4" },
          { name: "Shower Enclosures", path: "/product/5" },
          { name: "Led Mirrors", path: "/product/6" },
        ]}
      />
      {isAdmin && (
        <IconButton
          icon={<FiPower />}
          aria-label="Logout"
          colorScheme="red"
          variant="solid"
          borderRadius="full"
          onClick={handleLogout}
          position="absolute"
          top="90px"
          right="30px"
          zIndex="2"
          bg="rgba(255, 255, 255, 0.1)"
          color="white"
          backdropFilter="blur(10px)"
          border="1px solid rgba(255, 255, 255, 0.2)"
          _hover={{
            bg: "rgba(255, 255, 255, 0.2)",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
          }}
          _active={{
            bg: "rgba(255, 255, 255, 0.3)",
            boxShadow: "0 0 0 3px rgba(255, 255, 255, 0.4)",
          }}
          whileTap={{
            scale: 0.98,
            backgroundColor: "rgba(255, 255, 255, 0.4)",
          }}
        />
      )}
      <Box
        position="relative"
        bgImage={`url(${glass20})`}
        bgSize="cover"
        bgPosition="center"
        minH="100vh"
        px={6}
        py={12}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {/* DARK OVERLAY */}
        <Box
          position="absolute"
          top={0}
          left={0}
          w="100%"
          h="100%"
          bg="black"
          opacity={0.6} // Increase this for darker background
          zIndex={0}
        />
        <Flex
          direction={{ base: "column", md: "row" }}
          maxW="1000px"
          mx="auto"
          gap={10}
          align="start"
        >
          {/* LEFT PANEL */}
          <VStack
            align="start"
            spacing={6}
            flex="1"
            backdropFilter="blur(1.5px)"
            p={4}
            mt={{ base: 14, md: 4 }}
          >
            <Heading fontSize="3xl" color="white">
              Contact Us
            </Heading>
            {/* <Text fontSize="sm" color="#CBD5E0">
            Images from Freepik
          </Text> */}

            <HStack spacing={4} align="start">
              <Icon as={MdPhone} boxSize={6} color="#F6E05E" />
              <Box>
                <Text fontWeight="bold" color="white">
                  Let’s Talk
                </Text>
                <Link
                  href="tel:+916357117778"
                  isExternal
                  _hover={{ textDecoration: "none" }}
                >
                  <Text fontSize="sm" color="white">
                    +91 6357117778 / 80
                  </Text>
                </Link>
              </Box>
            </HStack>

            <HStack spacing={4} align="start">
              <Icon as={MdEmail} boxSize={6} color="#F6E05E" />
              <Box>
                <Text fontWeight="bold" color="white">
                  Email
                </Text>
                <Link
                  href="mailto:ensoglasssystem@gmail.com"
                  isExternal
                  _hover={{ textDecoration: "none" }}
                >
                  <Text fontSize="sm" color="white">
                    ensoglasssystem@gmail.com
                  </Text>
                </Link>
              </Box>
            </HStack>

            <HStack spacing={4} align="start">
              <Icon as={MdLocationOn} boxSize={6} color="#F6E05E" />
              <Box>
                <Text fontWeight="bold" color="white">
                  Location
                </Text>
                <Text fontSize="sm" color="white">
                  Ahmedabad, India
                </Text>
              </Box>
            </HStack>

            <HStack spacing={4} align="start">
              <Icon as={MdAccessTime} boxSize={6} color="#F6E05E" />
              <Box>
                <Text fontWeight="bold" color="white">
                  Business Hours
                </Text>
                <Text fontSize="sm" color="white">
                  Mon - Sat: 10am - 8pm
                </Text>
                <Text fontSize="sm" color="white">
                  Sun: Closed
                </Text>
              </Box>
            </HStack>
          </VStack>

          {/* RIGHT FORM PANEL */}
          <VStack
            spacing={4}
            flex="1"
            maxW="600px"
            w="full"
            align="stretch"
            backdropFilter="blur(1.5px)"
            pl={{base:4,md:8}}
            pr={{base:4,md:8}}
            pt={{base:4,md:8}}
            pb={{base:4,md:8}}
            borderRadius="lg"
          >
            <HStack spacing={4} align="start">
              <FormControl>
                <FormLabel color="white" mb="0.7rem">
                  Name
                  <Text as="span" color="red.500" ml={1}>
                    *
                  </Text>
                </FormLabel>
                <Input
                  name="name"
                  placeholder="Enter Name"
                  variant="unstyled"
                  borderBottom="1px solid white"
                  color="white"
                  _placeholder={{ color: "#CBD5E1" }}
                  focusBorderColor="white"
                  autoComplete="off"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  // handleInputChange={formik.handleChange}
                  // inputValue={formik.values.name}
                  // handleBlur={formik.handleBlur}
                  // posInputGroup={true}
                  // inputType={"text"}
                  // inputError={formik.touched.name && formik.errors.name}
                />
                <Text color={Colors.commonCancleButtonRed}>
                  {formik.touched.name && formik.errors.name ? (
                    <span>{formik.errors.name}</span>
                  ) : null}
                </Text>
              </FormControl>

              <FormControl>
                <FormLabel color="white" mb="0.7rem">
                  Phone
                  <Text as="span" color="red.500" ml={1}>
                    *
                  </Text>
                </FormLabel>
                <Input
                  name="phone"
                  placeholder="Enter Phone"
                  variant="unstyled"
                  borderBottom="1px solid white"
                  color="white"
                  autoComplete="off"
                  _placeholder={{ color: "#CBD5E1" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                  // focusBorderColor="white"
                  // handleInputChange={formik.handleChange}
                  // inputValue={formik.values.phone}
                  // handleBlur={formik.handleBlur}
                  // posInputGroup={true}
                  // inputType={"text"}
                  // inputError={formik.touched.phone && formik.errors.phone}
                />
                <Text color={Colors.commonCancleButtonRed}>
                  {formik.touched.phone && formik.errors.phone ? (
                    <span>{formik.errors.phone}</span>
                  ) : null}
                </Text>
              </FormControl>
            </HStack>

            <FormControl>
              <FormLabel color="white" mb="0.7rem">
                Email
                <Text as="span" color="red.500" ml={1}>
                  *
                </Text>
              </FormLabel>
              <Input
                name="email"
                placeholder="Enter Email"
                variant="unstyled"
                borderBottom="1px solid white"
                color="white"
                autoComplete="off"
                _placeholder={{ color: "#CBD5E1" }}
                focusBorderColor="white"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                // handleInputChange={formik.handleChange}
                // inputValue={formik.values.email}
                // handleBlur={formik.handleBlur}
                // posInputGroup={true}
                // inputType={"text"}
                // inputError={formik.touched.email && formik.errors.email}
              />
              <Text color={Colors.commonCancleButtonRed}>
                {formik.touched.email && formik.errors.email ? (
                  <span>{formik.errors.email}</span>
                ) : null}
              </Text>
            </FormControl>

            <FormControl>
              <FormLabel color="white" mb="0.7rem">
                Message
              </FormLabel>
              <Textarea
                name="note"
                placeholder="Enter Message"
                variant="unstyled"
                borderBottom="1px solid white"
                color="white"
                autoComplete="off"
                _placeholder={{ color: "#CBD5E1" }}
                focusBorderColor="white"
                resize="none"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.note}
                // onChange={formik.handleChange}
                // value={formik.values.note}
                // onBlur={formik.handleBlur}
                // inputerror={formik.touched.note && formik.errors.note}
              />
              <Text color={Colors.errorColor}>
                {formik.touched.note && formik.errors.note ? (
                  <span>{formik.errors.note}</span>
                ) : null}
              </Text>
            </FormControl>
            <HStack spacing={4} mt={4}>
              {/* <MotionButton
  bg="rgba(255, 255, 255, 0.1)"
  color="white"
  backdropFilter="blur(10px)"
  border="1px solid rgba(255, 255, 255, 0.2)"
  px={14}
  _hover={{
    bg: "rgba(255, 255, 255, 0.2)",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
  }}
  _active={{
    bg: "rgba(255, 255, 255, 0.3)",
    boxShadow: "0 0 0 3px rgba(255, 255, 255, 0.4)",
  }}
  whileTap={{
    scale: 0.98,
    backgroundColor: "rgba(255, 255, 255, 0.4)",
  }}
  onClick={() => {
    if (allformik) {
      setAllformik(false);
      formik.handleSubmit();
    } else {
      formik.handleSubmit();
    }
  }}
>
  <MotionBox
    initial={{ opacity: 1 }}
    animate={{ 
      opacity: [1, 0.8, 1],
      color: ["#fff", "#fff", "#fff"]
    }}
    transition={{ duration: 0.3 }}
  >
    Submit
  </MotionBox>
</MotionButton> */}
              <CommonFormButton
                // isDisabled={
                //   formik.values.name.length <= 0 ||
                //     formik.errors.name ||
                //     formik.errors.phone ||
                //     formik.errors.email ||
                //     buttonDisable
                //     ? true
                //     : false
                // }
                buttonsubmit={"Submit"}
                width={isMobile ? "8.4rem" : "11rem"}
                // onClick={formik.handleSubmit}
                onClick={() => {
                  if (allformik) {
                    setAllformik(false);
                    formik.handleSubmit();
                  } else {
                    formik.handleSubmit();
                  }
                }}
              />
              {isAdmin && (
                <CommonFormButton
                  borderRadius="full"
                  buttonsubmit={isMobile ? "Excel" : "Export to Excel"}
                  onClick={handleExportContact}
                  icon={<FaFileExcel />}
                  width={isMobile ? "8rem" : "10rem"}
                />
              )}
            </HStack>
          </VStack>
        </Flex>
      </Box>
      <Footer />
    </Box>
  );
};

export default Contact;
